import "./letter.scss";

import BannerImg from "../../../../assets/images/encyclopedia_banner.png";

export const EncyclopediaChapterLetter = (props: { letter: string }) => {
	return (
		<div className="letter_banner">
			<img src={BannerImg} alt=""></img>
			<div className="letter">{props.letter}</div>
		</div>
	);
};
